/* Cut-out pack shots in the cart.

   The cart line image is Shopify's, not the theme's: it is the variant image,
   or the product's featured image when the variant has none. The theme never
   chooses it, so it cannot be changed in a section -- and the snippet that
   renders it is too large to rewrite in one piece. This swaps it after the
   fact instead.

   SCOPE IS EVERYTHING, twice over.

   1. WHAT is matched: a link to /products/<handle>. The home page's product
      cards now link to the same place, so the swap is confined to cart
      containers. Do not widen CART to the document.

   2. WHEN it runs. This used to carry a MutationObserver on the whole body
      with subtree:true, which fired on every DOM change anywhere on the page
      -- including every frame of the Klaviyo popup opening and closing -- and
      ran a querySelectorAll per product each time. It was one of three
      body-wide observers doing that. It now watches the cart drawer itself
      once that exists, and otherwise only runs on the events that actually
      change the cart. If a cart image is ever missed, add the event that
      missed it; do not go back to watching the body.

   LIMIT: this is presentation only. Shopify's CHECKOUT, order confirmation
   emails and the admin still show the product's own image, because those are
   rendered by Shopify and never touch this theme. The only way to change
   those is to make the cut-out the product's featured image in admin.

   No regex literals: this file is written through an API that passes
   backslashes through verbatim, and an escaped slash would break the file. */
(function () {
  if (window.__irrShot) return;
  window.__irrShot = 1;

  /* Product handle -> cut-out shot. Add a line per product.
     These are the same files the home page product cards and the buy bar
     point at, so a product looks identical in the feed, in the fly-to-cart
     animation and in the cart. If one is re-exported, change it in BOTH
     places or they drift apart. The filenames are case sensitive. */
  var SHOTS = {
    'face-and-body-serum':
      'https://cdn.shopify.com/s/files/1/0812/7053/8520/files/150ml_irritated_face_and_body_serum_clear_background.png?v=1793634841',
    'face-body-serum-50ml':
      'https://cdn.shopify.com/s/files/1/0812/7053/8520/files/50ml_irritated_face_and_body_serum_clear_background.png?v=1793634841'
  };

  var CART = 'cart-drawer-component,cart-items-component,.cart-drawer,.cart-items,form[action="/cart"]';
  var LINE = 'li,tr,.cart-item,[class*="cart-item"],[class*="cart-product"]';

  var queued = false;
  var watched = null;

  function swapIn(scope) {
    Object.keys(SHOTS).forEach(function (handle) {
      scope.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (a) {
        var line = a.closest(LINE) || a.parentElement;
        if (!line) return;
        var img = line.querySelector('img');
        if (!img || img.dataset.irrShot) return;
        img.dataset.irrShot = '1';
        /* srcset and sizes win over src, so both have to go or the browser
           keeps serving the original from the responsive set. */
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = SHOTS[handle];
      });
    });
  }

  function swap() {
    queued = false;
    document.querySelectorAll(CART).forEach(swapIn);
    watch();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(swap);
  }

  /* The drawer's contents are replaced wholesale after every add and every
     quantity change, so watch THAT element -- not the page. */
  function watch() {
    if (!window.MutationObserver) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer === watched) return;
    watched = drawer;
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
  }

  schedule();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  }
  /* Listening to cart:update is safe; it is DISPATCHING it that breaks the
     theme's own components. */
  document.addEventListener('cart:update', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule);
})();
